export default [
  {
    keyword: 'sleepFor',
    valueType: 1,
    fieldName: 'sleepFor',
    default: 5,
    initializer: 5,
    units: {
      USCustomary: 's',
      Metric: 's',
    },
    tooltip: 'How long to sleep for',
    type: 'input',
    label: 'Sleep For',
  },
  {
    keyword: 'OverrideResourceMemory',
    valueType: 1,
    fieldName: 'OverrideResourceMemory',
    default: 200,
    min: 200,
    initializer: 200,
    type: 'input',
    label: 'Memory (Mb)',
    tooltip: 'The amount of RAM memory to request for the calculation',
    units: {
      USCustomary: 'Mb',
      Metric: 'Mb',
    },
  },
  {
    keyword: 'OverrideResourceCPU',
    valueType: 2,
    fieldName: 'OverrideResourceCPU',
    default: 1,
    min: 1,
    initializer: 1,
    type: 'input',
    label: 'CPU',
    tooltip: 'The amount of CPU to request for the calculation',
  },
  {
    keyword: 'HasAnalysisFiles',
    valueType: 1,
    fieldName: 'HasAnalysisFiles',
    default: 0,
    min: 0,
    initializer: 0,
    type: 'input',
    label: 'Upload Sample Analysis Files',
    tooltip: 'Setting this option will upload a set of sample analysis files to GCS, so user can download them from the Calculator Footer',
    transform: (value) => {
      if(value) {
        return 1
      }
      return 0
    },
    inverseTransform: (value) => {
      if(value === 1) {
        return true
      }
      return false
    },
  },
  {
    keyword: 'randomFailure',
    valueType: 1,
    fieldName: 'randomFailure',
    default: 0,
    min: 0,
    initializer: 0,
    type: 'input',
    label: 'Toggle Random Job Failure',
    tooltip: 'Setting this option will add a random chance that the job will fail to simulate error handling',
    transform: (value) => {
      if(value) {
        return 1
      }
      return 0
    },
    inverseTransform: (value) => {
      if(value === 1) {
        return true
      }
      return false
    },
  },
  {
    keyword: 'sleepVariant',
    keywordGroupName: 'variants',
    valueType: 0,
    fieldName: 'sleepVariant',
    default: 'normal',
    initializer: undefined,
    type: 'input',
    label: 'Sleep Variant',
    tooltip: 'Sleep Variant',
  },
  {
    keyword: 'ResultsFiles',
    valueType: 0,
    fieldName: 'resultsFiles',
    default: undefined,
    initializer: undefined,
    type: 'output',
    label: 'Analysis Files',
    tooltip: 'Analysis Files',
  },
  {
    keyword: 'sleptFor',
    valueType: 2,
    fieldName: 'sleptFor',
    initializer: undefined,
    type: 'output',
    units: {
      USCustomary: 's',
      Metric: 's',
    },
  },
]
